import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { FC } from 'react';

import { WidgetCard } from './widget-card';

export const CommunityStatsWidgetSkeleton: FC = () => (
  <WidgetCard title="Community Stats">
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {[0, 1].map(index => (
        // oxlint-disable-next-line react/jsx-key
        <Skeleton key={index} variant="text" width="100%" height={24} />
      ))}
    </Box>
  </WidgetCard>
);
